import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';

class ToggleCellRenderer extends Component {
  constructor() {
    super();
    this.state = {};
    this.handleToggle = this.handleToggle.bind(this);
  }
  handleToggle() {
    if (!this.props.disabled) {
      // is the field is no longer accessible, allow them to uncheck, do not allow them to check
      const { data, value } = this.props;
      const isNotAccessible = data?.accessible === false;
      if (!isNotAccessible || value) {
        this.props.onToggle(this.props.data);
      }
    }
  }
  renderContent() {
    const { value, isRadio, disabled, data } = this.props;
    const isNotAccessible = data?.accessible === false;

    if (isNotAccessible && (isRadio || !value)) {
      return null;
    }
    let name = value ? 'check-square' : 'square-o';
    if (isRadio) {
      name = value ? 'check-circle' : 'circle-o';
    }
    let cls = value ? 'text-success' : '';
    const styles = {
      cursor: disabled ? 'not-allowed' : 'pointer',
      fontSize: '1.3em',
    };
    if (disabled) {
      name = 'spinner';
      cls = 'text-muted';
    }
    if (isNotAccessible) {
      cls = 'text-danger';
    }
    return (
      <div className="text-center" style={styles} onClick={this.handleToggle}>
        <Fa name={name} className={cls} spin={disabled} />
      </div>
    );
  }
  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderContent();
    }
    return null;
  }
}

ToggleCellRenderer.propTypes = {
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  data: PropTypes.shape({
    accessible: PropTypes.bool,
  }).isRequired,
  node: PropTypes.shape({
    group: PropTypes.bool,
  }).isRequired,
  onToggle: PropTypes.func,
  isRadio: PropTypes.bool,
};
ToggleCellRenderer.defaultProps = {
  value: null,
  disabled: false,
  onToggle: () => {},
  isRadio: false,
};

export default ToggleCellRenderer;
